// Dependencies
require("webstrap/type");
require("grid");
require("section/generic");
require("element/rich-text");

// Styles
require("./confirmation.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/confirmation/index.js
 ** module id = 187
 ** module chunks = 0 1
 **/